import { TableQuoteItem } from '@paradigm/features/src/unified-rfqs/ui/types';
import createSafeContext from '@paradigm/utils/createSafeContext';

export interface ValueSelectors {
  selectPrice: (quote: Pick<TableQuoteItem, 'price'>) => void;
  selectQuantity: (quote: Pick<TableQuoteItem, 'quantity'>) => void;
}

export const [useValueSelectors, ValueSelectorsProvider] =
  createSafeContext<ValueSelectors>('ValueSelectors');
